import { render, staticRenderFns } from "./ResidentDetailModalForCooperationSystem.vue?vue&type=template&id=311cbbe6&lang=pug"
import script from "./ResidentDetailModalForCooperationSystem.vue?vue&type=script&lang=ts"
export * from "./ResidentDetailModalForCooperationSystem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports